export const filePondLabels = {
  labelDecimalSeparator: 'auto',
  labelThousandsSeparator: 'auto',
  labelIdle: 'Drag & Drop your files or <span class="filepond--label-action"> Browse </span>',
  labelInvalidField: 'Field contains invalid files',
  labelFileWaitingForSize: 'Waiting for size',
  labelFileSizeNotAvailable: 'Size not available',
  labelFileCountSingular: 'file in list',
  labelFileCountPlural: 'files in list',
  labelFileLoading: 'Loading',
  labelFileAdded: 'Added',
  labelFileLoadError: 'Error during load',
  labelFileRemoved: 'Removed',
  labelFileRemoveError: 'Error during remove',
  labelFileProcessing: 'Uploading',
  labelFileProcessingComplete: 'Upload complete',
  labelFileProcessingAborted: 'Upload cancelled',
  labelFileProcessingError: 'Error during upload',
  labelFileProcessingRevertError: 'Error during revert',
  labelTapToCancel: 'tap to cancel',
  labelTapToRetry: 'tap to retry',
  labelTapToUndo: 'tap to undo',
  labelButtonRemoveItem: 'Remove',
  labelButtonAbortItemLoad: 'Abort',
  labelButtonRetryItemLoad: 'Retry',
  labelButtonAbortItemProcessing: 'Cancel',
  labelButtonUndoItemProcessing: 'Undo',
  labelButtonRetryItemProcessing: 'Retry',
  labelButtonProcessItem: 'Upload',
}
